// Download helpers shared by Reports and the Finance P&L page: a CSV from
// headers + rows, and a print-to-PDF window around a simple table.
import { format } from 'date-fns';

export const downloadCSV = (filename, headers, rows) => {
  const csv = [headers, ...rows]
    .map(r => r.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(','))
    .join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href = url;
  a.download = `${filename}-${format(new Date(), 'yyyy-MM-dd')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const tableHtml = (headers, rows) => `
  <table>
    <thead><tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr></thead>
    <tbody>${rows.map(r => `<tr>${r.map(c => `<td>${c ?? ''}</td>`).join('')}</tr>`).join('')}</tbody>
  </table>`;

export const downloadPDF = (title, bodyHtml) => {
  const win = window.open('', '_blank');
  win.document.write(`
    <html><head><title>${title}</title>
    <style>
      body { font-family: Arial, sans-serif; font-size: 12px; margin: 20px; color: #0A1628; }
      h1 { font-size: 18px; margin-bottom: 4px; }
      p { color: #6B7A94; font-size: 11px; margin-bottom: 16px; }
      table { width: 100%; border-collapse: collapse; }
      th { background: #F8F6F0; padding: 8px 10px; text-align: left; font-size: 10px; text-transform: uppercase; letter-spacing: 0.05em; color: #6B7A94; border-bottom: 1px solid #E8E0D0; }
      td { padding: 8px 10px; border-bottom: 0.5px solid #E8E0D0; font-size: 12px; }
      tr:nth-child(even) td { background: #F1EDE3; }
      @media print { body { margin: 0; } }
    </style></head>
    <body>
      <h1>${title}</h1>
      <p>Generated ${format(new Date(), 'MMMM d, yyyy')} · A Heart For Care</p>
      ${bodyHtml}
      <script>window.onload = () => { window.print(); window.onafterprint = () => window.close(); }</script>
    </body></html>
  `);
  win.document.close();
};
